import React, { useState, useRef, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

export default function CustomPdfViewer({ fileUrl }) {
    const [numPages, setNumPages] = useState(null);
    const [containerWidth, setContainerWidth] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) return;
        const observer = new ResizeObserver((entries) => {
            setContainerWidth(Math.floor(entries[0].contentRect.width));
        });
        observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <Box ref={containerRef} sx={{ width: '100%' }}>
            <Document
                file={fileUrl}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                onLoadError={(err) => console.error('PDF 로드 실패:', err)}
                loading={
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 5 }}>
                        <CircularProgress size={40} sx={{ color: '#005a8d', mb: 2 }} />
                        <Typography sx={{ color: '#555', fontWeight: 600 }}>PDF를 불러오는 중입니다...</Typography>
                    </Box>
                }
            >
                {Array.from(new Array(numPages), (_, index) => (
                    <Box key={`page_${index + 1}`} sx={{ mb: 2 }}>
                        <Page
                            pageNumber={index + 1}
                            width={containerWidth || undefined}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                        />
                    </Box>
                ))}
            </Document>
        </Box>
    );
}

CustomPdfViewer.propTypes = {
    fileUrl: PropTypes.string.isRequired,
};
